import React from "react";
import { SvgBaseProps } from "../../interfaces";

const SVGLandingMintArrow = ({ color = "#FFF", className }: SvgBaseProps) => (
  <svg
    width="13"
    height="22"
    viewBox="0 0 13 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="2.10373" cy="2.46237" r="1.63888" fill={color} />
    <circle cx="6.50485" cy="6.86288" r="1.63888" fill={color} />
    <circle cx="10.9045" cy="11.2634" r="1.63888" fill={color} />
    <circle
      cx="2.10373"
      cy="20.0645"
      r="1.63888"
      transform="rotate(-90 2.10373 20.0645)"
      fill={color}
    />
    <circle
      cx="6.50485"
      cy="15.664"
      r="1.63888"
      transform="rotate(-90 6.50485 15.664)"
      fill={color}
    />
  </svg>
);

export default SVGLandingMintArrow;
